import clsx from 'clsx';

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------

type ScaledMockupProps = {
  /** The width the mockup is designed at, in px. */
  width: number;
  /** Full design height, including window chrome, reserved before hydration. */
  height: number;
  /** Largest scale to render at; the mockup shrinks below it to fit narrower containers. */
  maxScale?: number;
  className?: string;
  children: React.ReactNode;
};

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

/** Reserve the scaled footprint in CSS so hydration never moves the following section. */
const ScaledMockup: React.FC<ScaledMockupProps> = ({
  width,
  height,
  maxScale = 1,
  className,
  children,
}) => (
  <div
    className={clsx('relative w-full', className)}
    style={{
      maxWidth: width * maxScale,
      aspectRatio: `${width} / ${height}`,
      containerType: 'inline-size',
    }}
  >
    <div
      className="absolute top-0 left-0 origin-top-left"
      style={{ width, height, transform: `scale(tan(atan2(100cqw, ${width}px)))` }}
    >
      {children}
    </div>
  </div>
);

export default ScaledMockup;
